export default function formatDollar( value ) {
  const usdFormat = new Intl.NumberFormat( 'en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  } );

  return usdFormat.format( value );
}
